<template>
  <div>
    <div v-if="token">
      <keep-alive>
        <router-view :query="query" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <!-- 此处是为添加了keepAlive=false 的路由默认不缓存 -->
      <router-view :query="query" v-if="!$route.meta.keepAlive"/>
    </div>

    <!--悬浮-->
    <div class="floatbox" v-if="['/index', '/venue'].includes($route.path)">
      <img :src="require('@/assets/float.png')" @click="gotoOrder">
    </div>

    <!--底部栏-->
    <div v-show="!hiddenTabbar">
      <van-tabbar v-model="active" :placeholder="true">
        <van-tabbar-item
                v-for="(item, index) in filterTab"
                :key="index"
                :to="item.path">
          <span>{{item.name}}</span>
          <template #icon="props">
            <img :src="props.active ? item.active : item.inactive"/>
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
  import {myMixins} from "@/utils/loginMixins";
  import {queryList} from '@/api/activity/activity'
  export default {
    name: "BasicLayout",
    mixins: [myMixins],
    data() {
      return {
        token: '',
        activityShow: false,
        active: 0,
        tabList: [
          {
            name: '首页',
            inactive: require('@/assets/index.png'),
            active: require('@/assets/index-cur.png'),
            path: '/index',
            show: true
          },
          {name: '场馆', inactive: require('@/assets/cg.png'), active: require('@/assets/cg-cur.png'), path: '/venue', show: true},
          // {
          //   name: '师资',
          //   inactive: require('@/assets/tech.png'),
          //   active: require('@/assets/tech-cur.png'),
          //   path: '/teachers'
          // },
          {
            name: '师生互选',
            inactive: require('@/assets/tech.png'),
            active: require('@/assets/tech-cur.png'),
            path: '/activity',
            show: false
          },
          {name: '我的', inactive: require('@/assets/wo.png'), active: require('@/assets/wo-cur.png'), path: '/my', show: true},
        ],
        hiddenTabbar: false,
        query: {}
      }
    },
    watch: {
      $route: {
        handler: function (val) {
          this.routeRefresh(val)
        },
        // 深度观察监听
        deep: true
      }
    },
    computed: {
      filterTab () {
        return this.tabList.filter(i => i.show)
      }
    },
    created() {
      this.routeRefresh(this.$route)
      if (this.token) {
        this.getActivityList()
      }
    },
    methods: {
      routeRefresh(route) {
        const index = this.tabList.findIndex(i => i.path === route.path)
        if (index > -1) {
          this.active = index
        }
        if (route.meta && route.meta.hiddenTabbar) {
          this.hiddenTabbar = route.meta.hiddenTabbar
        } else {
          this.hiddenTabbar = false
        }

        this.query = route.query
      },
      gotoOrder(){
        this.$router.push({path: `/order/index`})
      },
      getActivityList() {
        const queryParams = {
          current: 1,
          size: 1
        }
        queryList(queryParams).then(res => {
          if (res.code === 10000) {
            if (res.result.total > 0) {
              this.tabList[2].show = true
              this.$forceUpdate()
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .floatbox {
    display: flex;
    width: 50px;
    height: 50px;
    position: fixed;
    right: 20px;
    bottom: 60px;
  }

  .floatbox img {
    width: 50px;
    height: 50px;
  }
  @media screen and (min-width:1024px){
    /deep/.van-tabbar{
      display: none !important;
    }
  }
</style>
